<template>
	<div
		:class="`formulate-input-element formulate-input-element--${context.class}`"
		:data-type="context.type"
	>
		<div class="custom-formulate-telegram--input">
			<span class="telegram-at mr-1 pl-0">@</span>
			<input
				id="custom-formulate-telegram"
				v-model.trim="context.model"
				type="text"
				v-bind="context.attributes"
				@blur="context.blurHandler"
			>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			checked: false,
		};
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-input[data-classification='text'] input {
    border: none !important;
}
.custom-control {
    min-height: 1.2rem;
}

.custom-formulate-telegram--input {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #949ABA !important;
}

.user-profile-field .formulate-input-wrapper .vs__selected input,
.user-profile-field .formulate-input-wrapper .formulate-input-element input {
    padding-left: 0 !important;
}
</style>
